<div class="tablewrap">

  <div class="header" *ngIf="!readonly">
    <button [disabled]="!canEditTrackers" class="btn_blue" (click)="onAddClick()">{{'Add photo'|translate}}</button>
  </div>
  <div class="images" *ngIf="!readonly">
    <div class="image_block" *ngFor="let object of Objects">
      <div class="edit_icons">
        <button [disabled]="!canEditTrackers" class="btn_img btn_edit" title="{{'Edit'|translate}}" (click)="onEditClick(object)"></button>
        <button [disabled]="!canEditTrackers" class="btn_img btn_remove" title="{{'Delete'|translate}}" (click)="onDeleteClick(object)"></button>
      </div>
      <div class="image_header">
        {{object.Name}}
      </div>
      <div class="image">
        <app-image-with-dialog [src]="'/ctrl/objects/photos/photo/'+object.Id"></app-image-with-dialog>
      </div>
    </div>
  </div>


  <div class="images" *ngIf="readonly">
    <div class="image" *ngFor="let object of Objects">
      <div class="image_header">
        {{object.Name}}
      </div>
      <div class="image">
        <app-image-with-dialog [src]="'/ctrl/objects/photos/photo/'+object.Id"></app-image-with-dialog>
      </div>
    </div>
  </div>

</div>
<template #mgmtDialog>
</template>
